// extracted by mini-css-extract-plugin
export default {"section":"SectionText_section__h4h+B","container":"SectionText_container__45ISK"};